import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Table, Input, Select } from 'hljd'
import { Link } from 'react-router'
import { ALBUM_KIND, VR_CREATE_PATH } from '@components/Hotel/constant'
import { VR_FILTER_LIST, PAGE_SIZE } from './constant'
import store from './store'
import styles from './index.module.less'
import cols from './cols'

@observer
export default class extends Component {
  UNSAFE_componentWillMount() {
    store.getHotelVrInfo()
  }

  UNSAFE_componentWillReceiveProps() {
    store.resetSearch()
  }

  render() {
    const { loading, list } = store
    const { Option } = Select

    return (
      <>
        <div className={styles['form-wrap']}>
          <Form layout="inline">
            <Form.Item>
              <Input
                onChange={store.searchByName}
                style={{ width: 240 }}
                placeholder="搜索全景名称"
              />
            </Form.Item>
            <Form.Item>
              {this.props.activeTab === ALBUM_KIND.VR && (
                <Select
                  onChange={store.searchByStatus}
                  style={{ width: 160, marginBottom: -11 }}
                  placeholder="全部状态"
                >
                  {VR_FILTER_LIST.map(({ value, text }) => (
                    <Option key={value} value={value}>
                      {text}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Link className={styles.button} to={VR_CREATE_PATH}>
                添加全景
              </Link>
            </Form.Item>
          </Form>
        </div>

        <Table
          className={styles.tabbox}
          bordered={false}
          loading={loading}
          columns={cols}
          dataSource={toJS(list)}
          pagination={{
            pageSize: PAGE_SIZE,
            hideOnSinglePage: true
          }}
          rowKey={record => record.id}
        />
      </>
    )
  }
}
